import React from "react";
import {connect,} from "~/redux/connect";
import {getResultsValue,} from "~/stateGetter";
import {getFitleredViewState,} from "~/StateGetters/FilteredViewStateGetters";
import {Button, Tooltip,} from "~/native-ui";

const TableRecordsCountAndTitle = React.memo(React.forwardRef(({ trans, recordsCount, title, ...props }, ref) => {
    const titleWithNumber = isNaN(recordsCount) ? title : trans("table.title_and_count", { count: Number(recordsCount), title }),
          text = React.useRef({ isTruncated: true, maxWidth: "150px" }).current,
          stack = React.useRef({ space: 2 }).current;

    return (
        <Tooltip tooltip={titleWithNumber}>
            <Button _stack={stack} _text={text} primary variant="outline" rightIcon="arrow-drop-down" iconProps={{ size: "sm" }} {...props}>
                {titleWithNumber}
            </Button>
        </Tooltip>
    )
}));

const mapStateToProps = (state, { modelId, title }) => {
    return {
        recordsCount: getResultsValue(state, modelId)?.total,
        title: getFitleredViewState(state, modelId).getFilteredViewTitle(),
    };
}


export default connect(mapStateToProps)(TableRecordsCountAndTitle);